


















import { Component, Ref } from "vue-property-decorator";
import Vue from "vue";
import Image from "@/models/image";

@Component
export default class Deco extends Vue {
  loading = true;

  cities: Array<Image> = [
    new Image(
      "https://www.urlcheckr.com/static/images/cities/amsterdam.jpg",
      "Amsterdam, Netherlands"
    ),
    new Image(
      "https://www.urlcheckr.com/static/images/cities/bangkok.jpg",
      "Bangkok, Thailand"
    ),
    new Image(
      "https://www.urlcheckr.com/static/images/cities/budapest.jpg",
      "Budapest, Hungary"
    ),
    new Image(
      "https://www.urlcheckr.com/static/images/cities/cairo.jpg",
      "Cairo, Egypt"
    ),
    new Image(
      "https://www.urlcheckr.com/static/images/cities/chicago.jpg",
      "Chicago, USA"
    ),
    new Image(
      "https://www.urlcheckr.com/static/images/cities/dubai.jpg",
      "Dubai, UAE"
    ),
    new Image(
      "https://www.urlcheckr.com/static/images/cities/jakarta.jpg",
      "Jakarta, Indonesia"
    ),
    new Image(
      "https://www.urlcheckr.com/static/images/cities/london.jpg",
      "London, United Kingdom"
    ),
    new Image(
      "https://www.urlcheckr.com/static/images/cities/mexico-city.jpg",
      "Mexico City, Mexico"
    ),
    new Image(
      "https://www.urlcheckr.com/static/images/cities/moscow.jpg",
      "Moscow, Russia"
    ),
    new Image(
      "https://www.urlcheckr.com/static/images/cities/mumbai.jpg",
      "Mumbai, India"
    ),
    new Image(
      "https://www.urlcheckr.com/static/images/cities/new-york.jpg",
      "New York City, USA"
    ),
    new Image(
      "https://www.urlcheckr.com/static/images/cities/paris.jpg",
      "Paris, France"
    ),
    new Image(
      "https://www.urlcheckr.com/static/images/cities/prague.jpg",
      "Prague, Czech Republic"
    ),
    new Image(
      "https://www.urlcheckr.com/static/images/cities/rome.jpg",
      "Rome, Italy"
    ),
    new Image(
      "https://www.urlcheckr.com/static/images/cities/seattle.jpg",
      "Seattle, USA"
    ),
    new Image(
      "https://www.urlcheckr.com/static/images/cities/seoul.jpg",
      "Seoul, South Korea"
    ),
    new Image(
      "https://www.urlcheckr.com/static/images/cities/tel-aviv.jpg",
      "Tel Aviv, Israel"
    ),
    new Image(
      "https://www.urlcheckr.com/static/images/cities/venice-beach.jpg",
      "Los Angeles, USA"
    ),
  ];

  get randomCity(): Image {
    return this.cities[Math.floor(Math.random() * this.cities.length)];
  }

  @Ref("decoRef")
  decoRef!: any;

  decoLoaded() {
    //
    this.decoRef.style.opacity = 1;
    this.loading = false;
    //
    // Fade the deco to 1
  }
}
